export default "__VITE_ASSET__Bix3wLWM__"